export default __webpack_public_path__ + "896f5c830b6c699a57f0284492953c50.png";